// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ts-2";
export var chatLink = "_ts-0";
export var chatText = "_ts-1";